import EstadisticasTemplate from "../components/templates/EstadisticasTemplate"

const Estadisticas = () => {
    return <EstadisticasTemplate/>;
};

export default Estadisticas;